(function () {
  var pageSize = 250;

  function storefrontRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function hasAvailableDiscount(product) {
    return (product.variants || []).some(function (variant) {
      var price = Number(variant.price);
      var compareAtPrice = Number(variant.compare_at_price);
      return variant.available && Number.isFinite(price) && Number.isFinite(compareAtPrice) && compareAtPrice > price;
    });
  }

  async function fetchDiscountedProducts(handle, productCount, limit) {
    var pageCount = Math.ceil(productCount / pageSize);
    var root = storefrontRoot();
    var pages = await Promise.all(Array.from({ length: pageCount }, async function (_, index) {
      var page = index + 1;
      var url = root + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=' + pageSize + '&page=' + page;
      var response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) {
        throw new Error('Collection products request failed with status ' + response.status + ' on page ' + page);
      }

      var data = await response.json();
      if (!Array.isArray(data.products)) {
        throw new Error('Collection products response was invalid on page ' + page);
      }
      return data.products;
    }));

    var productsByHandle = new Map();
    pages.flat().forEach(function (product) {
      if (hasAvailableDiscount(product)) {
        productsByHandle.set(product.handle, product);
      }
    });

    return Array.from(productsByHandle.values())
      .sort(function (a, b) {
        return Date.parse(b.created_at) - Date.parse(a.created_at);
      })
      .slice(0, limit);
  }

  async function fetchProductCard(handle, view) {
    var url = storefrontRoot() + 'products/' + encodeURIComponent(handle) + '?view=' + view;
    var response = await fetch(url);
    if (!response.ok) {
      throw new Error('Product card request failed with status ' + response.status + ' for ' + handle);
    }

    var documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
    var card = documentFragment.querySelector('.card-wrapper');
    if (!card) {
      throw new Error('Product card markup was missing for ' + handle);
    }
    return card;
  }

  async function fetchProductCards(products, view) {
    return Promise.all(products.map(function (product) {
      return fetchProductCard(product.handle, view);
    }));
  }

  var realSlideSelector = '.limited-deals__slide:not(.limited-deals__slide--placeholder)';

  function createSpinner() {
    var spinner = document.createElement('span');
    spinner.className = 'limited-deals__card-spinner';
    spinner.setAttribute('aria-hidden', 'true');
    return spinner;
  }

  function createPlaceholder(track) {
    var slide = document.createElement('li');
    slide.className = 'limited-deals__slide limited-deals__slide--placeholder';
    slide.setAttribute('aria-hidden', 'true');
    slide.innerHTML =
      '<div class="limited-deals__placeholder-card">' +
      '<div class="limited-deals__placeholder-media"></div>' +
      '<span class="limited-deals__placeholder-line"></span>' +
      '<span class="limited-deals__placeholder-line limited-deals__placeholder-line--short"></span>' +
      '</div>';
    slide.querySelector('.limited-deals__placeholder-media').appendChild(createSpinner());
    var sampleCard = track.querySelector(realSlideSelector + ' .card-wrapper');
    if (sampleCard) {
      slide.querySelector('.limited-deals__placeholder-card').style.minHeight = sampleCard.offsetHeight + 'px';
    }
    return slide;
  }

  // Keep a spinner over each new card's image until that image finishes loading.
  function showSpinnerUntilImageLoads(slide) {
    var media = slide.querySelector('.card__inner');
    var image = slide.querySelector('.card__media img');
    if (!media || !image || (image.complete && image.naturalWidth > 0)) return;

    var spinner = createSpinner();
    media.appendChild(spinner);
    var done = function () {
      spinner.remove();
    };
    image.addEventListener('load', done, { once: true });
    image.addEventListener('error', done, { once: true });
  }

  async function loadNextDealBatch(root, scrollTarget) {
    var slider = root.querySelector('[data-limited-deals-slider]');
    var track = root.querySelector('.limited-deals__track');
    var nextButton = root.querySelector('[data-limited-deals-next]');
    var status = root.querySelector('[data-limited-deals-status]');
    if (!slider || !track || !nextButton || root.dataset.loading === 'true') return;

    root.dataset.loading = 'true';
    slider.classList.add('is-loading');
    nextButton.disabled = true;
    nextButton.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'Loading more deals.';

    var placeholders = [];
    var placeholderCount = Math.min(
      Number(root.dataset.batchSize) || 0,
      (Number(root.dataset.cardLimit) || 0) - track.querySelectorAll(realSlideSelector).length
    );
    for (var placeholderIndex = 0; placeholderIndex < placeholderCount; placeholderIndex += 1) {
      var placeholder = createPlaceholder(track);
      placeholders.push(placeholder);
      track.appendChild(placeholder);
    }
    if (placeholders.length) {
      slider.dispatchEvent(new CustomEvent('limited-deals:placeholders-added', {
        detail: { scrollTarget: scrollTarget }
      }));
    }

    try {
      var handle = root.dataset.collectionHandle;
      var productCount = Number(root.dataset.productCount);
      var limit = Number(root.dataset.cardLimit);
      var batchSize = Number(root.dataset.batchSize);
      var existingCardCount = track.querySelectorAll(realSlideSelector).length;
      var remainingSlots = limit - existingCardCount;
      if (!handle || !Number.isFinite(productCount) || !Number.isFinite(limit) || !Number.isFinite(batchSize)) {
        throw new Error('Limited Deals collection settings are invalid.');
      }
      if (productCount < 1 || remainingSlots < 1) {
        root.dataset.hasMoreDeals = 'false';
        if (status) status.textContent = 'No more discounted products are available.';
        return;
      }

      if (!Array.isArray(root.discountedProducts)) {
        root.discountedProducts = await fetchDiscountedProducts(handle, productCount, limit);
      }

      var existingHandles = new Set(Array.from(track.querySelectorAll(realSlideSelector))
        .map(function (slide) { return slide.dataset.productHandle; })
        .filter(Boolean));
      if (root.dataset.featuredHandle) existingHandles.add(root.dataset.featuredHandle);
      var batch = root.discountedProducts
        .filter(function (product) { return !existingHandles.has(product.handle); })
        .slice(0, Math.min(batchSize, remainingSlots));
      if (!batch.length) {
        root.dataset.hasMoreDeals = 'false';
        if (status) status.textContent = 'No more discounted products are available.';
        return;
      }

      var view = root.dataset.showQuickAdd === 'true'
        ? 'limited-deal-card-quick-add'
        : 'limited-deal-card';
      var cards = await fetchProductCards(batch, view);
      if (cards.length !== batch.length) {
        throw new Error('Not all requested deal cards were returned.');
      }

      var fragment = document.createDocumentFragment();
      var newSlides = [];
      batch.forEach(function (product, index) {
        var slide = document.createElement('li');
        slide.className = 'limited-deals__slide';
        slide.dataset.productHandle = product.handle;
        slide.appendChild(cards[index]);
        newSlides.push(slide);
        fragment.appendChild(slide);
      });
      track.insertBefore(fragment, placeholders[0] || null);
      placeholders.forEach(function (placeholder) {
        placeholder.remove();
      });
      placeholders = [];
      newSlides.forEach(showSpinnerUntilImageLoads);

      var loadedHandles = new Set(Array.from(track.querySelectorAll(realSlideSelector))
        .map(function (slide) { return slide.dataset.productHandle; })
        .filter(Boolean));
      if (root.dataset.featuredHandle) loadedHandles.add(root.dataset.featuredHandle);
      var hasMoreDeals = root.discountedProducts.some(function (product) {
        return !loadedHandles.has(product.handle);
      }) && track.querySelectorAll(realSlideSelector).length < limit;
      root.dataset.hasMoreDeals = hasMoreDeals ? 'true' : 'false';
      if (status) status.textContent = 'More deals loaded.';
      slider.dispatchEvent(new CustomEvent('limited-deals:rendered', {
        detail: { scrollTarget: scrollTarget }
      }));
    } catch (error) {
      if (status) status.textContent = 'Could not load more deals. Please try again.';
      console.error('Limited Deals could not load the next discounted product batch.', error);
    } finally {
      placeholders.forEach(function (placeholder) {
        placeholder.remove();
      });
      delete root.dataset.loading;
      slider.classList.remove('is-loading');
      nextButton.removeAttribute('aria-busy');
      slider.dispatchEvent(new CustomEvent('limited-deals:loading-complete'));
    }
  }

  function initialize(root) {
    if (root.dataset.limitedDealsInitialized === 'true') return;
    var slider = root.querySelector('[data-limited-deals-slider]');
    if (!slider) return;

    root.dataset.limitedDealsInitialized = 'true';
    slider.addEventListener('limited-deals:load-next', function (event) {
      var scrollTarget = event.detail && event.detail.scrollTarget;
      loadNextDealBatch(root, scrollTarget);
    });

    var nextButton = root.querySelector('[data-limited-deals-next]');
    if (nextButton) {
      nextButton.addEventListener('click', function () {
        if (root.dataset.hasMoreDeals === 'true') {
          loadNextDealBatch(root);
        }
      });
    }
  }

  function initializeAll(scope) {
    if (scope.matches && scope.matches('[data-limited-deals-products]')) {
      initialize(scope);
    }
    scope.querySelectorAll('[data-limited-deals-products]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); }, { once: true });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
